import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'fe-rental-flexible',
    templateUrl: './rental-flexible.component.html',
    styleUrls: ['./rental-flexible.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class RentalFlexibleComponent implements OnInit {
    imageSrc = '';
    isEnglish = false;
    constructor(private router: Router) {}

    ngOnInit(): void {
        this.setImageByLocale();
        this.isEnglish = this.router.url.startsWith('/en/');
    }

    setImageByLocale() {
        const url = this.router.url;

        this.imageSrc = url.startsWith('/en/')
            ? 'images/rent-car-mockup.png'
            : 'images/renta-auto-mockup.png';
    }

    beneficios = [
        {
            icono: 'images/contrato.svg',
            titulo: 'fe_lp_renta_flexible_benefit_1',
            descripcion: 'fe_lp_renta_flexible_benefit_desc_1',
        },
        {
            icono: 'images/deducible.svg',
            titulo: 'fe_lp_renta_flexible_benefit_2',
            descripcion: 'fe_lp_renta_flexible_benefit_desc_2',
        },
        {
            icono: 'images/seguro.svg',
            titulo: 'fe_lp_renta_flexible_benefit_3',
            descripcion: 'fe_lp_renta_flexible_benefit_desc_3',
        },
        {
            icono: 'images/tarifas.svg',
            titulo: 'fe_lp_renta_flexible_benefit_4',
            descripcion: 'fe_lp_renta_flexible_benefit_desc_4',
        },
        {
            icono: 'images/mantenimiento.svg',
            titulo: 'fe_lp_renta_flexible_benefit_5',
            descripcion: 'fe_lp_renta_flexible_benefit_desc_5',
        },
        {
            icono: 'images/atencion.svg',
            titulo: 'fe_lp_renta_flexible_benefit_6',
            descripcion: 'fe_lp_renta_flexible_benefit_desc_6',
        },
        {
            icono: 'images/flotilla.svg',
            titulo: 'fe_lp_renta_flexible_benefit_7',
            descripcion: 'fe_lp_renta_flexible_benefit_desc_7',
        },
        {
            icono: 'images/cobertura.svg',
            titulo: 'fe_lp_renta_flexible_benefit_8',
            descripcion: 'fe_lp_renta_flexible_benefit_desc_8',
        },
    ];
}
